module.exports = __webpack_public_path__ + "static/img/vib_rf_medical_biotechnology_rgb_neg.bf623aa1.png";